import React, { PureComponent } from 'react';
import styled from 'styled-components';
import PhotoLibrary from '@material-ui/icons/PhotoLibrary';
import Location from '@solvhealth/types/interfaces/Location';
import CircleImage from './CircleImage';
import { getImageObject, PHOTO } from './Picture/util';
import { colors } from '../../constants/colors';
import { fontFamily, fontSize } from '../../constants/text';
import { Viewport } from '~/components/useViewport';

const Overlay = styled.div.withConfig({ componentId: 'sc-tyj1pu-0' })`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  color: ${colors.white};
  opacity: 0;
  background-color: rgba(0, 0, 0, 0);
  z-index: 1;
  transition: opacity 200ms ease, background-color 200ms ease;
  cursor: pointer;
  text-align: center;

  &:hover {
    background-color: rgba(0, 0, 0, 0.4);
    opacity: 1;
  }

  &:before {
    content: '';
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
`;

const PhotoIcon = styled(PhotoLibrary).withConfig({ componentId: 'sc-tyj1pu-1' })`
  width: 18px;
  height: 18px;
  vertical-align: text-bottom;
`;

type OwnProps = {
  handleOpenCarousel?: (...args: any[]) => any;
  location: Location;
  viewport?: Viewport;
  className?: string;
  thumbnailSize?: string;
  showThumbnail?: boolean;
};

type Props = OwnProps & typeof ClinicPhoto.defaultProps;

class ClinicPhoto extends PureComponent<Props> {
  static defaultProps = {
    thumbnailSize: 'medium',
  };

  getImageObject = () =>
    getImageObject(this.props.location, {
      imageType: PHOTO,
      imageIndex: 0,
      viewport: this.props.viewport,
      showDefaultPictureIfMissing: true,
    });

  render() {
    const {
      location: { displayNamePrimary, displayNameSecondary, city, state },
      handleOpenCarousel,
      className,
      thumbnailSize,
    } = this.props;
    const clinicName = `${displayNamePrimary} ${
      displayNameSecondary ? `, ${displayNameSecondary}` : ''
    }`;

    const cityState = `${city}, ${state}`;

    return (
      <CircleImage
        alt={`Photo for ${clinicName}, (${cityState})`}
        className={className}
        imageObject={this.getImageObject()}
        onClick={handleOpenCarousel}
        showThumbnail
        thumbnailSize={thumbnailSize}
      >
        {handleOpenCarousel && (
          <Overlay>
            <PhotoIcon /> View Photos
          </Overlay>
        )}
      </CircleImage>
    );
  }
}

export default ClinicPhoto;
